<template>
	<Comment />
</template>

<script>
import Comment from '../../components/Comment.vue'
export default {
	name: 'BookComment',
	components:{
		Comment
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/BookDetails/BookComment.vue